import {mapGetters, mapActions, mapMutations} from "vuex";

export default {
    data(){
      return{
          changeRate: false,
          currency_value: 0,
          // Статичні визначення полів: перекладні підписи — labelKey,
          // сам `label` обчислюється в computed fields (залежить від локалі).
          fieldDefs: [
              {
                  key: 'id',
                  label: 'id'
              },
              {
                  key: 'rate',
                  labelKey: 'rateList.rate'
              },
              {
                  key: 'employee_id',
                  labelKey: 'rateList.employee'
              },
              {
                  key: 'created_at',
                  labelKey: 'rateList.created'
              },
          ],
          items:[],
      }
    },
    components: {
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide: 'config/menuHide',
            actualRate: 'rate/actualRate',
            rate: 'rate/rate',
            users:'contacts/usersForSelect',
        })
    },
    watch:{
        rate(e){
            if(e && e.data.length){
                e.data.map(item =>{
                    let actualUser = (this.users || []).filter(userItem=> userItem.id === item.employee_id)
                    actualUser = actualUser[0]
                    this.items.push({
                        id: item.id,
                        rate: Number(item.currency_value).toFixed(2),
                        created_at: this.$moment(item.created_at).format('YYYY-MM-DD HH:mm:ss'),
                        employee_id: actualUser ? actualUser.name : '—',
                    })
                })
            }
        }
    },
    created() {
        this.getUsersForSelect().then(()=>{
            this.getRate();
        });
        this.getRateActual();
    },
    methods:{
        sendChangeRate(){
          this.sendNewRate({
              currency_value: this.currency_value
          }).then(res=>{
              if(res.status){
                  this.changeRate = true
                  this.changeRateMutation(null);
                  this.getRate();
                  this.getRateActual().then(()=>{
                      this.currency_value = this.actualRate.value;
                  });
              }
          })
        },
        openChangeRate(){
            this.changeRate = true;
            this.currency_value = this.actualRate.value;
        },
        ...mapActions({
            getRate:'rate/getRate',
            sendNewRate:'rate/sendNewRate',
            getRateActual:'rate/getRateActual',
            getUsersForSelect:'contacts/getUsersForSelect',
        }),
        ...mapMutations({
            changeRateMutation:'rate/changeRate'
        })
    },

}